import React, { Component } from "react";
import { Typography, Slider, Tooltip } from "@material-ui/core";
import { withStyles } from "@material-ui/styles";

const RangeSlider = withStyles({
  root: {
    color: "#007bff",
    width: "300px",
  },
})(Slider);

const FilterNameTypography = withStyles({
  root: {
    color: "#082d66",
  },
})(Typography);

const ValuesTypography = withStyles({
  root: {
    color: "#8091af",
  },
})(Typography);

class RangeFilter extends Component {
  state = {
    description: this.props.description,
    min: this.props.min,
    max: this.props.max,
    value: this.props.currentValue,
  };

  handleChange = (event, newValue) => {
    this.setState({ value: newValue });
  };

  componentDidUpdate(prevProps) {
    if (prevProps.currentValue !== this.props.currentValue) {
      this.setState({ value: this.props.currentValue });
    }
  }

  formatNumber(number) {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
  }

  render() {
    return (
      <div className="filter-box">
        <FilterNameTypography variant="h6" id="range-slider">
          {this.state.description}
        </FilterNameTypography>
        <ValuesTypography variant="body2">
          {this.formatNumber(this.state.value[0])} -{" "}
          {this.formatNumber(this.state.value[1])}
        </ValuesTypography>
        <Tooltip title="nastaveni koncovych hodnot filtru" placement="right">
          <RangeSlider
            value={this.state.value}
            onChange={this.handleChange}
            onChangeCommitted={() =>
              this.props.changeFilterValue(this.state.value)
            }
            aria-labelledby="range-slider"
            min={this.state.min}
            max={this.state.max}
          />
        </Tooltip>
      </div>
    );
  }
}

export default RangeFilter;
